import { Component } from './component';
import type { FrameworkProvider } from '../provider';

export class Service extends Component {
  declare readonly framework: FrameworkProvider;
  readonly __isService = true;
  readonly __injectable = true;
}
